import store from '@/store';

var registryService = (function() {

  var loadRegistries = function(to) {
    if (to.meta.registries == undefined) { return false }
    return _invokeLoadAndSetOfRegistries(to.meta.registries);
  }

  var _invokeLoadAndSetOfRegistries = function(registryPaths) {
    for (const registryPath of registryPaths) {
      store.dispatch('registries/loadRegistries', registryPath);
    }
    return 
  }

  return { loadRegistries: loadRegistries }
})();

export default registryService;
